import MomentUtils from '@date-io/moment';
import { createGenerateClassName, StylesProvider } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { react_core_config } from '@pbl/pbl-react-core/lib/config/config';
import { API, AUTHAPI } from '@pbl/pbl-react-core/lib/services';
import { SessionService } from '@pbl/pbl-react-core/lib/services/session-service';
import { DateFormatterType } from '@pbl/pbl-react-core/lib/utils/DateTimeFormatter';
import * as NumberUtil from '@pbl/pbl-react-core/lib/utils/NumberUtil';
import { now } from '@pbl/pbl-react-core/lib/utils/TimeUtil';
import { assets, config } from '@pbl/pbl-react-web-components/lib/package';
import { FrameworkContext } from '@pbl/pbl-react-widgets/lib/widgets/framework';
import { IGoInterface, IGoInternalInterface } from '@pbl/pbl-react-widgets/lib/widgets/framework.types';
import 'assets/css/app.css';
import 'assets/css/pbl-mobile-fonticon.css';
import ActiveLegendIcon from 'assets/img/active-legend.png';
import EndedLegendIcon from 'assets/img/ended-legend.png';
import collectCheckLogo from 'assets/img/icons-check@1x.png';
import LottoPrintNPlayTicket from 'assets/img/lotto-printnplay-logo.png';
import LottoTicket from 'assets/img/lotto-ticket.png';
import Mnlogo from 'assets/img/mnLogo.png';
import colors from 'assets/jss/colors';
import constants, { RemoteConstants } from 'config/constants';
import { getTicketTab, helpTabs } from 'config/ticket';
import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistentStore, store } from 'redux/store';
import { apiAuthConfiguration } from 'utils/apiAuthConfig';
import { addRequestTransform, addResponseTransform, apiConfiguration } from 'utils/apiConfig';
import Widgets from './widgets/Widgets';
import SuperBonusIcon from 'assets/img/sbeImage.png';
import SignInIcon from 'assets/img/signin-icon.png';

const generateClassName = createGenerateClassName({
  productionPrefix: 'eWidget-global-',
  disableGlobal: true,
  seed: 'eWidget-global'
});

interface IProps {
  goFw: IGoInterface;
  goFwInternal: IGoInternalInterface;
}

const App: React.FC<IProps> = props => {
  const coreConfig = {
    lotteryTimeZone: constants.LOTTERY_TIME_ZONE,
    minDateOfBirth: now(constants.LOTTERY_TIME_ZONE)
      .subtract(120, 'years')
      .toDate(),
    maxDateOfBirth: now(constants.LOTTERY_TIME_ZONE)
      .subtract(21, 'years')
      .toDate(),
    currencyFormat: constants.CURRENCY_FORMAT,
    currencyFormatWithDecimal: constants.CURRENCY_FORMAT_WITH_DECIMAL,
    instantGameType: constants.INSTANT_GAMES_TYPE_ID,
    gameType: constants.DEFAULT_GAME_TYPE,
    showGameTypeFilter: constants.SHOW_GAME_TYPE_FILTER,
    defaultDateFormat: constants.DEFAULT_DATE_FORMAT,
    dateFormatter: {
      historyDateFormat: DateFormatterType.DateFormat,
      drawDrawDateFormat: DateFormatterType.DateFormat,
      drawStartEndDateFormat: DateFormatterType.DateFormat
    },
    addressBaseUrl: constants.ADDRESS_URL,
    pointsFormat: constants.POINTS_FORMAT,
    promoEndingSoonDays: constants.DRAW_ENDING_SOON_PERIOD,
    arcadeGameType: constants.ARCADE_GAME_TYPE,
    lotteryId: constants.LOTTERY_ID,
    gatewayV2: constants.GATEWAY_V2,
    skipGender: constants.SKIP_GENDER
  };
  config.coreConfig = coreConfig;
  react_core_config.internalConfig = coreConfig;
  // @ts-ignore
  config.themeColors = { ...colors };
  // @ts-ignore
  assets.internalAssets = {
    activeLegendImg: ActiveLegendIcon,
    endedLegendImg: EndedLegendIcon,
    shieldIcon: '',
    claimItAll: '',
    quickDrawImages: '',
    claimItAllSecondary: '',
    mnlogo: Mnlogo,
    lottoTicket: LottoTicket,
    printNPlay: LottoPrintNPlayTicket
  };
  // @ts-ignore
  config.internalConfig = {
    CURRENCY_FORMAT: constants.CURRENCY_FORMAT,
    BUTTON_BACKGROUND: 'primary',
    DRAW_ICON: 'icon-draws',
    BASE_URL: constants.BASE_URL,
    DATE_FORMAT: constants.DATE_FORMAT,
    DATE_TIME_FORMAT: constants.DATE_TIME_FORMAT,
    REWARDS_MAXIMUM: constants.REWARDS_MAXIMUM,
    TABLE_CELL_BACKGROUND: 'primary',
    EARN_ICON: 'icon-KS-earn',
    GAME_DRAWS_PER_PAGE: constants.GAME_DRAWS_PER_PAGE,
    DRAW_ENDING_SOON_PERIOD: constants.DRAW_ENDING_SOON_PERIOD,
    PHONE_MASK: constants.PHONE_MASK,
    HISTORY_FILTER_START_DAYS: constants.HISTORY_FILTER_START_DAYS,
    TICKET_TABS_DATA: getTicketTab(),
    TICKET_HELP_DATA: helpTabs,
    REWARDS_ICON: 'icon-WV-Rewards-Solid',
    SHOW_IMAGE_PREFIX: false,
    DISABLE_EARN_CORNER_ICON: constants.DISABLE_EARN_CORNER_ICON,
    FIELDS_VARIANT: constants.FIELDS_VARIANT,
    SHOW_WINNER_ANNOUNCEMENT_DATE: constants.SHOW_WINNER_ANNOUNCEMENT_DATE,
    SHOW_BONUS_POINTS: constants.SHOW_BONUS_POINTS,
    HIDE_SUBMIT_TICKET_BUTTON: constants.HIDE_SUBMIT_TICKET_BUTTON,
    HIDE_DETAIL_TILE_CONTENT: constants.HIDE_DETAIL_TILE_CONTENT,
    REMOVE_SECOND_CHANCE_TAB_FILTER: constants.REMOVE_SECOND_CHANCE_TAB_FILTER,
    COUPON_BACKGROUND: constants.COUPON_BACKGROUND,
    SHOW_REWARD_TYPE_COLUMN: constants.SHOW_REWARD_TYPE_COLUMN
};
  // @ts-ignore
  config.themeColors = { ...colors };

  assets.internalAssets = {
    noImage: 'https://s3.amazonaws.com/po-dev-cdn/images/no-image.svg',
    pointsEarnedImg: 'https://gateway-qa.loyalty.wvlottery.com/services/media/api/file/75/ee866594-a9f9-4259-b240-bf708b903d21',
    noFeaturedImg: 'https://s3.amazonaws.com/po-dev-cdn/images/no-image-featured.svg',
    facebookLogo: 'https://s3.amazonaws.com/po-dev-cdn/images/facebook-logo.png',
    instagramLogo: 'https://s3.amazonaws.com/po-dev-cdn/images/instagram-logo.png',
    twitterLogo: 'https://s3.amazonaws.com/po-dev-cdn/images/twitter-logo.png',
    rewardDownloadLogo: 'https://s3.amazonaws.com/po-dev-cdn/images/reward-download.svg',
    rewardRedeemLogo: 'https://s3.amazonaws.com/po-dev-cdn/images/rewardRedeemed.png',
    playLogo: 'https://loyalty-dev-nc-cdn.s3.amazonaws.com/images/play_icon.png',
    activeLegendImg: require('../src/assets/img/active-legend.png').default,
    endedLegendImg: require('../src/assets/img/ended-legend.png').default,
    superBonusImg: SuperBonusIcon,
    arcadeTagBG: '',
    emptyCart: '',
    tokenSecondary: '',
    tokenPrimary: '',
    freeClaim: '',
    cvvHelper: '',
    kenoHotNumberImg: 'https://loyalty-dev-nc-cdn.s3.amazonaws.com/images/hot-ball.png',
    kenoColdNumberImg: 'https://loyalty-dev-nc-cdn.s3.amazonaws.com/images/cold-ball.png',
    otwImage: '',
    otwLogo: '',
    ftffImage: '',
    ftffLogo: '',
    iconAlertWarning: '',
    shieldIcon: '',
    claimItAll: '',
    quickDrawImages: '',
    claimItAllSecondary: '',
    collectCheckLogoIcon: collectCheckLogo,
    starImg: require('../src/assets/img/did-you-know-star.png').default,
    bonusIcon: require('../src/assets/img/icon-left-badge-bonus.png').default,
    correctIcon: require('../src/assets/img/Correct.png').default,
    incorrectIcon: require('../src/assets/img/Incorrect.png').default,
    signInIcon: SignInIcon
  };

  React.useEffect(() => {
    RemoteConstants.syncConfig();

    API.setup(apiConfiguration, {
      requestTransFormation: { addRequestTransform, addResponseTransform }
    });
    AUTHAPI.setup(apiAuthConfiguration, {
      requestTransFormation: { addRequestTransform, addResponseTransform }
    });
    SessionService.status();
    NumberUtil.loadNewCurrencyFormat();
  }, []);

  return (
    <StylesProvider generateClassName={generateClassName}>
    <FrameworkContext.Provider value={{ internal: props.goFwInternal, external: props.goFw }}>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <Provider store={store}>
          <PersistGate persistor={persistentStore}>
            <React.Fragment>
              <Widgets {...props} />
            </React.Fragment>
          </PersistGate>
        </Provider>
      </MuiPickersUtilsProvider>
    </FrameworkContext.Provider>
    </StylesProvider>
  );
};

export default App;
